import { useEffect, useState } from "react";
import { fetchSponsors, Sponsor } from "../api/contentful";

export function useSponsors() {
  const [data, setData] = useState<Sponsor[] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchSponsors()
      .then((res) => setData(res))
      .catch((err) => setError(err.message || "Failed to load sponsors"))
      .finally(() => setLoading(false));
  }, []);

  return { data, loading, error };
}
